<template>
  <section :class="['card-profile-details', { full: page }]">
    <card-profile-images :card="card" :page="page" />

    <card-profile-stats
      :card="card"
      :card-id="cardId"
      :is-admin="isAdmin"
      :is-public="isPublic"
      :is-staff="isStaff"
      :page="page"
    />
  </section>
</template>

<script>
import CardProfileImages from './CardProfileImages';
import CardProfileStats from './CardProfileStats';

export default {
  components: {
    CardProfileImages,
    CardProfileStats,
  },

  props: {
    card: Object,
    cardId: String,
    isAdmin: Boolean,
    isPublic: Boolean,
    isStaff: Boolean,
    page: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.card-profile-details {
  display: grid;
  grid-gap: $gp;
  margin-bottom: $gp;
  grid-template-columns: repeat(2, 1fr);

  &:not(.full) {
    flex-direction: column;
    grid-template-columns: repeat(1, 1fr);
  }

  @media($medium-down) {
    flex-direction: column;
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
